// extracted by mini-css-extract-plugin
module.exports = {"infoCard":"_18Ldl","icon":"mKYCK","icon_app":"W4ysQ","icon_card":"VqCRm"};